import MapManager from "@/services/map/mapManager";
import { LayerType, isCommunityLayerById, isPlaceLayerById, GeoType, VisualizationType } from '@/services/map/types';
import chroma from "chroma-js";
import colorExpression from "@/utils/colorExpression";

const colors = {
  PulseDaypart: ['#e5482c'],
  GrowthTrends: ['#2C7BE5', '#ffffff', '#e5482c']
};

// TODO: This is temporary, we should be using a library like colorama or something to generate these ramps based on a "base color"
const defaultColorRamp = [{ "value": 0, "color": "#C5FBF6" }, { "value": 0.05, "color": "#ABE1F7" }, { "value": 0.11, "color": "#92C7F8" }, { "value": 0.16, "color": "#78ADF9" }, { "value": 0.21, "color": "#5F93FB" }, { "value": 0.26, "color": "#5889FB" }, { "value": 0.32, "color": "#527FFB" }, { "value": 0.37, "color": "#4C76FB" }, { "value": 0.42, "color": "#466CFB" }, { "value": 0.47, "color": "#4063FB" }, { "value": 0.53, "color": "#3A59FB" }, { "value": 0.58, "color": "#3450FB" }, { "value": 0.63, "color": "#2E46FB" }, { "value": 0.68, "color": "#283DFB" }, { "value": 0.74, "color": "#2233FB" }, { "value": 0.79, "color": "#1C2AFB" }, { "value": 0.84, "color": "#1620FB" }, { "value": 0.89, "color": "#1017FB" }, { "value": 0.95, "color": "#0A0DFB" }, { "value": 1, "color": "#0404FB" }];
const routesColorRamp = [{ "value": 0, "color": "#3548FF" }, { "value": 0.01, "color": "#3152FF" }, { "value": 0.02, "color": "#2E5CFF" }, { "value": 0.03, "color": "#2B66FF" }, { "value": 0.04, "color": "#2870FF" }, { "value": 0.05, "color": "#257AFF" }, { "value": 0.06, "color": "#2284FF" }, { "value": 0.07, "color": "#1F8EFF" }, { "value": 0.08, "color": "#1C98FF" }, { "value": 0.09, "color": "#18A2FF" }, { "value": 0.1, "color": "#15ACFF" }, { "value": 0.11, "color": "#12B6FF" }, { "value": 0.12, "color": "#0FC0FF" }, { "value": 0.13, "color": "#0CCAFF" }, { "value": 0.14, "color": "#09D4FF" }, { "value": 0.15, "color": "#06DEFF" }, { "value": 0.16, "color": "#03E8FF" }, { "value": 0.17, "color": "#00F3FF" }, { "value": 0.18, "color": "#00F3F5" }, { "value": 0.19, "color": "#00F4EC" }, { "value": 0.2, "color": "#00F4E3" }, { "value": 0.21, "color": "#00F5DA" }, { "value": 0.22, "color": "#00F5D0" }, { "value": 0.23, "color": "#00F6C7" }, { "value": 0.24, "color": "#00F7BE" }, { "value": 0.25, "color": "#00F7B5" }, { "value": 0.26, "color": "#00F8AB" }, { "value": 0.27, "color": "#00F8A2" }, { "value": 0.28, "color": "#00F999" }, { "value": 0.29, "color": "#00F990" }, { "value": 0.3, "color": "#00FA86" }, { "value": 0.31, "color": "#00FB7D" }, { "value": 0.32, "color": "#00FB74" }, { "value": 0.33, "color": "#00FC6B" }, { "value": 0.34, "color": "#00FC61" }, { "value": 0.35, "color": "#00FD58" }, { "value": 0.36, "color": "#00FD4F" }, { "value": 0.37, "color": "#00FE46" }, { "value": 0.38, "color": "#00FF3D" }, { "value": 0.39, "color": "#0AFF3A" }, { "value": 0.4, "color": "#15FF37" }, { "value": 0.41, "color": "#1FFF35" }, { "value": 0.42, "color": "#2AFF32" }, { "value": 0.43, "color": "#34FF2F" }, { "value": 0.44, "color": "#3FFF2D" }, { "value": 0.45, "color": "#49FF2A" }, { "value": 0.46, "color": "#54FF27" }, { "value": 0.47, "color": "#5FFF25" }, { "value": 0.48, "color": "#69FF22" }, { "value": 0.49, "color": "#74FF1F" }, { "value": 0.51, "color": "#7EFF1D" }, { "value": 0.52, "color": "#89FF1A" }, { "value": 0.53, "color": "#93FF17" }, { "value": 0.54, "color": "#9EFF15" }, { "value": 0.55, "color": "#A9FF12" }, { "value": 0.56, "color": "#B3FF0F" }, { "value": 0.57, "color": "#BEFF0D" }, { "value": 0.58, "color": "#C8FF0A" }, { "value": 0.59, "color": "#D3FF07" }, { "value": 0.6, "color": "#DDFF05" }, { "value": 0.61, "color": "#E8FF02" }, { "value": 0.62, "color": "#F3FF00" }, { "value": 0.63, "color": "#F3FC00" }, { "value": 0.64, "color": "#F3FA00" }, { "value": 0.65, "color": "#F3F800" }, { "value": 0.66, "color": "#F4F500" }, { "value": 0.67, "color": "#F4F300" }, { "value": 0.68, "color": "#F4F100" }, { "value": 0.69, "color": "#F5EF00" }, { "value": 0.7, "color": "#F5EC00" }, { "value": 0.71, "color": "#F5EA00" }, { "value": 0.72, "color": "#F6E801" }, { "value": 0.73, "color": "#F6E601" }, { "value": 0.74, "color": "#F6E301" }, { "value": 0.75, "color": "#F7E101" }, { "value": 0.76, "color": "#F7DF01" }, { "value": 0.77, "color": "#F7DC01" }, { "value": 0.78, "color": "#F8DA01" }, { "value": 0.79, "color": "#F8D801" }, { "value": 0.8, "color": "#F8D601" }, { "value": 0.81, "color": "#F9D302" }, { "value": 0.82, "color": "#F9D102" }, { "value": 0.83, "color": "#F9CF02" }, { "value": 0.84, "color": "#FACD02" }, { "value": 0.85, "color": "#FACA02" }, { "value": 0.86, "color": "#FAC802" }, { "value": 0.87, "color": "#FBC602" }, { "value": 0.88, "color": "#FBC302" }, { "value": 0.89, "color": "#FBC102" }, { "value": 0.9, "color": "#FCBF03" }, { "value": 0.91, "color": "#FCBD03" }, { "value": 0.92, "color": "#FCBA03" }, { "value": 0.93, "color": "#FDB803" }, { "value": 0.94, "color": "#FDB603" }, { "value": 0.95, "color": "#FDB403" }, { "value": 0.96, "color": "#FEB103" }, { "value": 0.97, "color": "#FEAF03" }, { "value": 0.98, "color": "#FEAD03" }, { "value": 0.99, "color": "#FFAB04" }, { "value": 1, "color": "#FF0202" }];
const heatColorRamp = [{ "value": 0, "color": "rgba(53, 72, 255, 0)" }, { "value": 0.01, "color": "#3152FF" }, { "value": 0.02, "color": "#2E5CFF" }, { "value": 0.03, "color": "#2B66FF" }, { "value": 0.04, "color": "#2870FF" }, { "value": 0.05, "color": "#257AFF" }, { "value": 0.06, "color": "#2284FF" }, { "value": 0.07, "color": "#1F8EFF" }, { "value": 0.08, "color": "#1C98FF" }, { "value": 0.09, "color": "#18A2FF" }, { "value": 0.1, "color": "#15ACFF" }, { "value": 0.11, "color": "#12B6FF" }, { "value": 0.12, "color": "#0FC0FF" }, { "value": 0.13, "color": "#0CCAFF" }, { "value": 0.14, "color": "#09D4FF" }, { "value": 0.15, "color": "#06DEFF" }, { "value": 0.16, "color": "#03E8FF" }, { "value": 0.17, "color": "#00F3FF" }, { "value": 0.18, "color": "#00F3F5" }, { "value": 0.19, "color": "#00F4EC" }, { "value": 0.2, "color": "#00F4E3" }, { "value": 0.21, "color": "#00F5DA" }, { "value": 0.22, "color": "#00F5D0" }, { "value": 0.23, "color": "#00F6C7" }, { "value": 0.24, "color": "#00F7BE" }, { "value": 0.25, "color": "#00F7B5" }, { "value": 0.26, "color": "#00F8AB" }, { "value": 0.27, "color": "#00F8A2" }, { "value": 0.28, "color": "#00F999" }, { "value": 0.29, "color": "#00F990" }, { "value": 0.3, "color": "#00FA86" }, { "value": 0.31, "color": "#00FB7D" }, { "value": 0.32, "color": "#00FB74" }, { "value": 0.33, "color": "#00FC6B" }, { "value": 0.34, "color": "#00FC61" }, { "value": 0.35, "color": "#00FD58" }, { "value": 0.36, "color": "#00FD4F" }, { "value": 0.37, "color": "#00FE46" }, { "value": 0.38, "color": "#00FF3D" }, { "value": 0.39, "color": "#0AFF3A" }, { "value": 0.4, "color": "#15FF37" }, { "value": 0.41, "color": "#1FFF35" }, { "value": 0.42, "color": "#2AFF32" }, { "value": 0.43, "color": "#34FF2F" }, { "value": 0.44, "color": "#3FFF2D" }, { "value": 0.45, "color": "#49FF2A" }, { "value": 0.46, "color": "#54FF27" }, { "value": 0.47, "color": "#5FFF25" }, { "value": 0.48, "color": "#69FF22" }, { "value": 0.49, "color": "#74FF1F" }, { "value": 0.51, "color": "#7EFF1D" }, { "value": 0.52, "color": "#89FF1A" }, { "value": 0.53, "color": "#93FF17" }, { "value": 0.54, "color": "#9EFF15" }, { "value": 0.55, "color": "#A9FF12" }, { "value": 0.56, "color": "#B3FF0F" }, { "value": 0.57, "color": "#BEFF0D" }, { "value": 0.58, "color": "#C8FF0A" }, { "value": 0.59, "color": "#D3FF07" }, { "value": 0.6, "color": "#DDFF05" }, { "value": 0.61, "color": "#E8FF02" }, { "value": 0.62, "color": "#F3FF00" }, { "value": 0.63, "color": "#F3FC00" }, { "value": 0.64, "color": "#F3FA00" }, { "value": 0.65, "color": "#F3F800" }, { "value": 0.66, "color": "#F4F500" }, { "value": 0.67, "color": "#F4F300" }, { "value": 0.68, "color": "#F4F100" }, { "value": 0.69, "color": "#F5EF00" }, { "value": 0.7, "color": "#F5EC00" }, { "value": 0.71, "color": "#F5EA00" }, { "value": 0.72, "color": "#F6E801" }, { "value": 0.73, "color": "#F6E601" }, { "value": 0.74, "color": "#F6E301" }, { "value": 0.75, "color": "#F7E101" }, { "value": 0.76, "color": "#F7DF01" }, { "value": 0.77, "color": "#F7DC01" }, { "value": 0.78, "color": "#F8DA01" }, { "value": 0.79, "color": "#F8D801" }, { "value": 0.8, "color": "#F8D601" }, { "value": 0.81, "color": "#F9D302" }, { "value": 0.82, "color": "#F9D102" }, { "value": 0.83, "color": "#F9CF02" }, { "value": 0.84, "color": "#FACD02" }, { "value": 0.85, "color": "#FACA02" }, { "value": 0.86, "color": "#FAC802" }, { "value": 0.87, "color": "#FBC602" }, { "value": 0.88, "color": "#FBC302" }, { "value": 0.89, "color": "#FBC102" }, { "value": 0.9, "color": "#FCBF03" }, { "value": 0.91, "color": "#FCBD03" }, { "value": 0.92, "color": "#FCBA03" }, { "value": 0.93, "color": "#FDB803" }, { "value": 0.94, "color": "#FDB603" }, { "value": 0.95, "color": "#FDB403" }, { "value": 0.96, "color": "#FEB103" }, { "value": 0.97, "color": "#FEAF03" }, { "value": 0.98, "color": "#FEAD03" }, { "value": 0.99, "color": "#FFAB04" }, { "value": 1, "color": "#FF0202" }];

function interpolate(x, x1, x2, y1, y2) {
  return y1 + (x - x1) * ((y2 - y1) / (x2 - x1));
}

function interleave([x, ...xs], ...rest) {
  return x === undefined
    ? rest.length === 0
      ? []
      : interleave(...rest)
    : [x, ...interleave(...rest, xs)];
}

function generateColors([...colors], low, high, steps = 20) {
  if (colors.length === 1) {
    const highColor = colors[0];
    const lowColor = chroma(highColor).brighten(4).hex();
    const colorScale = chroma.scale([lowColor, highColor]).colors(steps);
    const numberScale = [];
    for (let i = 0; i < steps; i++) {
      numberScale.push(Math.round(interpolate(i, 0, steps - 1, low, high)));
    }
    return interleave(numberScale, colorScale);
  } else if (colors.length === 3) {
    steps = steps % 2 === 0 ? steps : steps + 1;

    const negativeColor = colors[0];
    const interColor = colors[1];
    const positiveColor = colors[2];
    const colorScale = chroma.scale([negativeColor, interColor]).colors(steps / 2).concat(chroma.scale([interColor, positiveColor]).colors(steps / 2));

    const numberScale = [];
    for (let i = 0; i < steps; i++) {
      numberScale.push(interpolate(i, 0, steps - 1, low, high));
    }
    return interleave(numberScale, colorScale);

  } else {
    throw new Error('Could not generate color expression.');
  }

}

function generateOpacities(low, hi, steps = 20, minOpacity = 0, maxOpacity = 0.7) {
  const numberScale = [];
  for (let i = 0; i < steps; i++) {
    numberScale.push(interpolate(i, 0, steps, low, hi));
  }
  const opacityScale = [];
  // TODO: We need to account for low being negative
  // * That means instead of interpolating the value from the range [low to hi], we use the distance from 0 to set the opacity
  for (let i = 0; i < steps; i++) {
    const val = low < 0 ? Math.abs(numberScale[i]) : numberScale[i];
    opacityScale.push(Math.min(Math.max(minOpacity, interpolate(val, low < 0 ? 0 : low, hi, 0, 1)), maxOpacity));
  }
  return interleave(numberScale, opacityScale);

}

export default class LayerManager extends MapManager {

  constructor(mapInstance, mapService) {
    super(mapInstance);
    this.mapService = mapService;
    this.layerIds = new Set();
    this.childLayers = {};
  }

  isLayerLoaded(layerId) {
    let layerLoaded = this.map.getLayer(layerId) !== undefined;
    if (layerId in this.childLayers) {
      for (const childId of this.childLayers[layerId]) {
        if (this.map.getLayer(childId) !== undefined) layerLoaded = true;
        else layerLoaded = false;
      }
    }
    if (layerLoaded && !this.layerIds.has(layerId)) this.layerIds.add(layerId);
    return layerLoaded;

  }

  addLayer(layer, overwrite = false, parentId = undefined) {

    return new Promise((resolve, reject) => {
      if (this.isLayerLoaded(layer.id)) {
        if (overwrite) this.removeLayer(layer.id);
        else return reject(new Error(`Layer ${layer.id} already exists, set overwrite=true`));
      }

      if (parentId && !(parentId in this.childLayers)) this.childLayers[parentId] = [];

      this.map.addLayer(layer);

      const helper = (evt) => {
        if (typeof this.map.getLayer(layer.id) !== 'undefined') {
          this.layerIds.add(layer.id);
          if (parentId) this.childLayers[parentId].push(layer.id);
          this.emit("addlayer", { layerId: layer.id });
          this.map.off('styledata', helper);
          return resolve();
        }
      };

      this.map.on('styledata', helper);
    });

  }

  removeChildLayers(layerId) {
    for (const childId of this.childLayers[layerId]) {
      try {
        this.map.removeLayer(childId);
        this.layerIds.delete(childId);
      } catch (er) {
        if (err.includes('does not exist')) {
          this.layerIds.delete(childId);
          throw err;
        } else {
          console.log({ err });
          throw err;
        }
      }
    }
  }

  removeLayer(layerId) {
    if (this.isLayerLoaded(layerId)) {
      if (layerId in this.childLayers) {
        this.removeChildLayers(layerId);
      } else {
        try {
          this.map.removeLayer(layerId);
        } catch (err) {
          if (!err.includes('does not exist')) {
            console.log({ err });
            throw err;
          }
        }
      }
    }
    delete this.childLayers[layerId];
    this.layerIds.delete(layerId);
    this.emit("removelayer", { layerId });

  }

  createLayerData({ id, filters, colorRamp, batch }) {
    let layer = {
      id,
      source: id,
      paint: {},
    };

    let zoomLevel = 8;

    switch (filters.visualization) {
      case VisualizationType.HEXBIN.name:
        layer.type = "fill";
        if (colorRamp) layer.paint['fill-color'] = ["interpolate", ['linear'], ['get', 'density'], ...colorExpression(colorRamp).flat()];
        else layer.paint['fill-color'] = ["interpolate", ['linear'], ['get', 'density'], ...colorExpression(defaultColorRamp).flat()];
        layer.paint["fill-opacity"] = ['interpolate', ['linear'], ['get', 'weighted_density'], ...generateOpacities(0, 100, 20, 0.1, 0.6)];

        // Change the zoom level based on resolution
        zoomLevel += (filters.api_params.resolution - 6);

        break;
      case VisualizationType.HEATMAP.name:
        layer.type = "heatmap";
        layer.paint["heatmap-color"] = ["interpolate", ["linear"], ["heatmap-density"], ...colorExpression(heatColorRamp).flat()];
        layer.paint["heatmap-weight"] = ["interpolate", ["linear"], ["get", "density"], 0, 0, 1, 1];
        layer.paint["heatmap-intensity"] = ["interpolate", ["linear"], ["zoom"], 0, 0, 15, 1];
        layer.paint["heatmap-radius"] = ["interpolate", ["linear"], ["zoom"], 0, 1, 7, 2, 15, 80];
        layer.paint["heatmap-opacity"] = 0.6;
        layer.maxzoom = 15;
        zoomLevel = 9;

        break;
      case VisualizationType.ROUTES.name:
        layer.type = "line";
        layer.paint["line-color"] = ["interpolate", ["linear"], ["get", "density"], ...colorExpression(routesColorRamp).flat()];
        layer.paint["line-width"] = ["interpolate", ["linear"], ["zoom"], 0, 1, 23, 5];
        layer.paint["line-opacity"] = ["get", "opacity"];
        layer.layout = {};
        layer.layout["line-sort-key"] = ["get", "count"];
        layer.layout["line-join"] = "round";

        zoomLevel = 11;

        break;
      case VisualizationType.ADMIN.name:
        layer.type = "fill";
        if (colorRamp) layer.paint['fill-color'] = ["interpolate", ['linear'], ['get', 'density'], ...colorExpression(colorRamp).flat()];
        else layer.paint['fill-color'] = ["interpolate", ['linear'], ['get', 'density'], ...colorExpression(defaultColorRamp).flat()];
        layer.paint['fill-opacity'] = ["interpolate", ["linear"], ["get", "weighted_density"], ...generateOpacities(0, 100, 20, 0.1, 0.6)];

        // Change zoom level based on GeoType
        switch (filters.geography_level) {
          case GeoType.ADMIN:
            zoomLevel = 8;
            break;
          case GeoType.POSTAL:
            zoomLevel = 9;
            break;
          case GeoType.CENSUS:
            zoomLevel = 10;
            break;
        }
        break;
      case VisualizationType.PD.name:
        layer.type = "fill";
        layer["source-layer"] = "geojsonLayer";
        const highColor = colors['PulseDaypart'][0];
        const lowColor = chroma(highColor).brighten(4).hex();
        layer["paint"] = {
          'fill-color': [
            'interpolate',
            ['exponential', 10 / 12],
            ['get', 'density'], 0, lowColor, 3000, highColor],
          'fill-opacity': ['interpolate', ['exponential', 1000 / 1001], ['get', 'density'], 0, 0, 3000, 1],
          'fill-outline-color': '#ffffff',
        };
        layer.maxzoom = 15;
        zoomLevel = 10;
        break;
      case VisualizationType.GT.name:
        layer.type = "fill";
        layer["source-layer"] = "geojsonLayer";
        let colorMinMax;
        let opacityMinMax;
        switch (filters.api_params.months) {
          case '6':
            colorMinMax = 0.15;
            opacityMinMax = 0.08;
            break;
          case '12':
            colorMinMax = 0.04;
            opacityMinMax = 0.04;
            break;
          case '18':
            colorMinMax = 0.02;
            opacityMinMax = 0.02;
            break;
        }
        layer["paint"] = {
          'fill-color': [
            'interpolate',
            ['linear'],
            ['get', 'trend'], ...generateColors(colors['GrowthTrends'], -colorMinMax, colorMinMax, 100)],
          'fill-opacity': ['interpolate', ['linear'], ['get', 'trend'], ...generateOpacities(-opacityMinMax, opacityMinMax, 100)],
          'fill-outline-color': '#ffffff',
        };
        zoomLevel = 10;
        break;
      case VisualizationType.CL.name:
      case VisualizationType.PLACES_CLUSTER.name:
        let circle_color = "#6e84a3";
        if (filters.visualization == VisualizationType.PLACES_CLUSTER.name) {
          circle_color = "#2C7BE5"; 
        }
        const shadowLayer = Object.assign({}, layer);
        shadowLayer.id = layer.id + "_shadow";
        shadowLayer.type = "circle";
        shadowLayer.source = layer.id;
        shadowLayer["source-layer"] = "geojsonLayer";
        shadowLayer.filter = [">", "count", 1];
        shadowLayer.paint = {
          "circle-color": circle_color,
          "circle-radius": [
            "step",
            ["get", "count"],
            28,
            100,
            38,
            1000,
            48
          ],
          "circle-opacity": 0.5
        };


        const clusterLayer = Object.assign({}, layer);
        clusterLayer.id = layer.id + "_cluster";
        clusterLayer.type = "circle";
        clusterLayer.source = layer.id;
        clusterLayer["source-layer"] = "geojsonLayer";
        clusterLayer.filter = [">", "count", 1];
        clusterLayer.paint = {
          "circle-color": circle_color,
          "circle-radius": [
            "step",
            ["get", "count"],
            20,
            100,
            30,
            1000,
            40
          ]
        };

        const countLayer = Object.assign({}, layer);
        countLayer.id = layer.id + "_count";
        countLayer.type = "symbol";
        countLayer.source = layer.id;
        countLayer["source-layer"] = "geojsonLayer";
        countLayer.filter = [">", "count", 1];
        countLayer.paint = {
          "text-color": "#ffffff"
        };
        countLayer.layout = {
          "text-field": ["number-format", ["get", "count"], {}],
          'text-font': ['Arial Unicode MS Bold'],
          'text-size': 12,
        };
        
        // Just for debugging
//        const pinLayer = Object.assign({}, layer);
//        pinLayer.id = layer.id + "_pin";
//        pinLayer.type = "circle";
//        pinLayer.source = layer.id;
//        pinLayer["source-layer"] = "geojsonLayer";
//        pinLayer.filter = ["!has", "count"];
//        pinLayer.paint = {
//          "circle-color": "pink",
//          "circle-radius": 10
//        };

      
        return { layers: [shadowLayer, clusterLayer, countLayer], zoomLevel };
    
      case VisualizationType.PLACES_CHOROPLETH.name:

        const postalLayer = 
            {
                'id': id+"_postal", // Layer ID
                'type': 'fill',
                'source': id, // ID of the tile source created above
                'source-layer': 'postal',
                'minzoom': 7,
                'paint': {
                    'fill-color':  [
                      'interpolate',
                      ['linear'],
                      ['get', 'count_normalized'],
                      0,
                      '#FFFFFF',
                      0.000005,
                      '#E2EAF3',
                      0.015,
                      '#2C7BE5'
                      ],
                    'fill-outline-color': ['case', ['==', 0, ['get', 'count_normalized']], '#ccc', '#FFFFFF'],
                    'fill-opacity': 0.5,
                },

            };
        const adminLayer = 
            {
                'id': id+"_admin", // Layer ID
                'type': 'fill',
                'source': id, // ID of the tile source created above
                'source-layer': 'admin',
                'minzoom': 5,
                'maxzoom': 7,
                'paint': {
                    'fill-color':  [
                      'interpolate',
                      ['linear'],
                      ['get', 'count_normalized'],
                      0,
                      '#FFFFFF',
                      0.000005,
                      '#E2EAF3',
                      0.075,
                      '#2C7BE5'
                      ],
                    'fill-outline-color': ['case', ['==', 0, ['get', 'count_normalized']], '#ccc', '#FFFFFF'],
                    'fill-opacity': 0.5,
                },

            };
            console.log(adminLayer);
        const provinceLayer = 
            {
                'id': id+"_province", // Layer ID
                'type': 'fill',
                'source': id, // ID of the tile source created above
                'source-layer': 'province',
                //'minzoom': <?=$admin_break?>,
                'maxzoom': 5,
                'paint': {
                    'fill-color':  [
                      'interpolate',
                      ['linear'],
                      ['get', 'count_normalized'],
                      0,
                      '#FFFFFF',
                      0.000005,
                      '#E2EAF3',
                      11,
                      '#2C7BE5'
                      ],
                    'fill-outline-color': ['case', ['==', 0, ['get', 'count_normalized']], '#ccc', '#FFFFFF'],
                    'fill-opacity': 0.5,
                },

            };
        return { layers: [postalLayer, adminLayer, provinceLayer], zoomLevel };
    }

    if (batch) {
      layer.paint['fill-color'] = ["get", "color"];

    }
    return { layer, zoomLevel };
  }

  clearLayers() {

    this.layerIds.forEach(layerId => {
      this.removeLayer(layerId)
    });
    this.emit("clearlayers");

  }

  hideLayer(layerId) {

    if (layerId in this.childLayers) {
      for (const id of this.childLayers[layerId]) {
        this.map.setLayoutProperty(id, "visibility", "none");
      }
    } else {
      this.map.setLayoutProperty(layerId, "visibility", "none");
    }

  }

  showLayer(layerId) {

    if (layerId in this.childLayers) {
      for (const id of this.childLayers[layerId]) {
        this.map.setLayoutProperty(id, "visibility", "visible");
      }
    } else {
      this.map.setLayoutProperty(layerId, "visibility", "visible");
    }

  }

  hideLayers({ layerType }) {

    if (layerType === undefined) this.layerIds.forEach(layerId => this.hideLayer(layerId));
    else if (layerType === LayerType.COMMUNITY.name) this.layerIds.forEach(layerId => {
      if (isCommunityLayerById(layerId)) this.hideLayer(layerId);
    });
    else if (layerType === LayerType.PLACE.name) this.layerIds.forEach(layerId => {
      if (isPlaceLayerById(layerId)) this.hideLayer(layerId);
    });

  }

  showLayers({ layerType }) {


    if (layerType === undefined) this.layerIds.forEach(layerId => this.showLayer(layerId));
    else if (layerType === LayerType.COMMUNITY.name) this.layerIds.forEach(layerId => {
      if (isCommunityLayerById(layerId)) this.showLayer(layerId);
    });
    else if (layerType === LayerType.PLACE.name) this.layerIds.forEach(layerId => {
      if (isPlaceLayerById(layerId)) this.showLayer(layerId);
    });

  }

}